<template>
  <div id="modal1" class="modal modalShown">
    <div v-bind:id="imageId" class="full-image" style="background-color: white">
      <img :src="data.imageUrl" :alt="data.title" />
      <button
        class="full-image-btn btn"
        @click="imgCloseFull"
        :style="{
          'background-image': `url(${require('@/assets/images/CycleRoute/CloseBTN.svg')})`,
        }"
      ></button>
    </div>

    <div>
      <div class="modal-header container">
        <div>
          <h4>{{ data.title }}</h4>
          <p>{{ data.subtitle }}</p>
        </div>

        <button
          class="modal-btn fullscreen btn"
          style="margin-bottom: 20px; margin-right: 20px"
          :style="{
            'background-image': `url(${require('@/assets/images/CycleRoute/FullscreenBTN.svg')})`,
          }"
          @click="imgFullScreen"
        ></button>
        <button
          class="modal-btn close btn"
          style="margin-bottom: 20px"
          :style="{
            'background-image': `url(${require('@/assets/images/CycleRoute/CloseBTN.svg')})`,
          }"
          @click="closeModal"
          z
        ></button>
      </div>

      <img :src="data.imageUrl" :alt="data.title" class="modal-img" />
    </div>
  </div>
</template>

<script>
export default {
  name: "MapModal",
  props: {
    data: Object,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      imageId: `fullimage${this.data.pinId}`,
    };
  },

  methods: {
    closeModal() {
      this.$emit("modalClosed", this.data.id);
    },
    imgFullScreen() {
      let image = document.getElementById(this.imageId);
      let header = document.getElementById("header-panel");
      header.setAttribute("style", "display:none;");
      image.classList.add("active");
    },
    imgCloseFull() {
      let image = document.getElementById(this.imageId);
      let header = document.getElementById("header-panel");
      header.setAttribute("style", "display:block;");
      image.classList.remove("active");
    },
  },
};
</script>

<style lang="scss" scoped>
.full-image {
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  display: none;
}

.full-image.active {
  display: block;
}

.full-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.full-image-btn {
  position: fixed;
  top: 50px;
  right: 60px;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  box-shadow: none !important;
  outline: none;
  padding: 0 !important;
  background-size: cover;
}

.modalShown {
  display: block;
}

.modal-img {
  width: 100%;
  max-height: 60vh;
  object-fit: cover;
}

.modal-btn {
  border-radius: 50%;
  padding: 0 !important;
  background-color: transparent;
  background-size: cover;
  box-shadow: none !important;
}

.fullscreen {
  width: 45px;
  height: 45px;
}

.close {
  height: 45px;
  width: 45px;
  margin-bottom: 5px !important;
}
</style>
